import { useMemo } from "react";
import { useIntlFormatterLocales } from "./useIntlFormatterLocales";

export function useListFormatter(
  type: Intl.ListFormatOptions["type"] = "conjunction"
) {
  const locales = useIntlFormatterLocales();
  return useMemo(
    () =>
      new Intl.ListFormat(locales, {
        type,
      }),
    [locales, type]
  );
}
